import { Option } from "../../../util/option";
export type GetGeneralCodesResponse = {
  /**
   * The results of this get_general_codes response body.
   */
  gnrlCdTypeList: GnrlCdType[];
};

type GnrlCdType = {
  cdType: string;
  cdTypeName: string;
  cdList: Option[];
};
